/** @format */
import { css } from 'styled-components';

const baseStyles = css`
    .original-price {
        text-decoration: line-through;
        color: var(--colors-text-primary);
    }
`;

export const styles = css`
    ${baseStyles}
`;
